export class IntercomStep {
  async run(navigationInstruction, next) {
    if (window.Intercom) {
      window.Intercom('update');
    }
    return next();
  }
}